import React from 'react'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'
import Layout from '@/components/Layout'
import ContentHeader from '@/components/ContentHeader'

export default function ReturnsRefunds() {
  const {t} = useTranslation()
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'terms-of-service-mobile-container' : 'terms-of-service-container'

  return (
    <Layout
      isDetailPage={true}
      detailPageTitle={t('Returns and Refunds')}>
      <div className={rootClassName}>
        <ContentHeader
          className={'home-header-container'}
          des={t('Returns and Refunds')}
          title={t('')}
          title2={t('Returns and Refunds')}
        />
        <div className={'terms-of-service-content-container'}>
          {/*<div>
            These Terms of Service ("Agreement") govern your use of [Your Company Name]'s services, website, mobile application, or any other digital platform (collectively referred to as the "Service"). By accessing or using the Service, you agree to be bound by this Agreement.
          </div>*/}
          <div>
            <div className={'terms-of-service-content-list-item-container'}>
              <p>1. Refund Policy</p>
              A refund, or credit, for the cost of unopened merchandise, less a 15% restocking fee, will be issued when merchandise is returned within 10 days of receipt. Shipping cost will only be refunded if the return is due to an error made by Apoodr Inc.

              Please note: Apoodr Inc is not responsible for items opened or damaged due to high pressure/altitude. These items will not be refunded or accepted for return.

              Out of Stock Items

              Due to Apoodr Inc's large variety of items and constant volume of sales, occasionally, items listed for sale on the e-store may be out of stock.  Apoodr Inc will issue an immediate refund for items ordered but currently not in stock.

            </div>
            
            <div className={'terms-of-service-content-list-item-container'}>
              <p>2. Return Policy</p>
              Products Damaged, Shipped in Error, or Not Received
              Products are free of damage and breakage when your order is shipped from our warehouses. Although Apoodr Inc products are packaged very carefully, damages may occur in transit or products may not reach their final destination. Please contact Customer Service if you receive a damaged or broken product, or if you have not received your order. You will be asked to provide proof by photo to sunny@apoodr.com along with your order number attached, via email.

              Make sure to save all contents, including packaging, for FedEx to investigate on any damaged order. Apoodr Inc will then submit a claim to the carrier for their investigation. The investigation may take up to two business weeks to complete. Replacement items will not be shipped until the claim process has been resolved.

              Shipping charges on the original order will be refunded or a credit given only if the merchandise is damaged in transit or was shipped in error.
            </div>
            
            <div className={'terms-of-service-content-list-item-container'}>
              <p>3. Unopened Merchandise</p>
              Unopened merchandise may be returned within 10 days of receipt. Return shipping charges will be the customer’s responsibility. Returned items will be subject to a 15% restocking fee and original shipping charges will not be refunded.
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
